import { FormatListBulleted } from '@mui/icons-material'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'
import { Alert, Box, FormControlLabel, Switch, Typography } from '@mui/material'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import 'dayjs/locale/es'
import { useEffect, useState } from 'react'
import TeamCalendarAccordeon from '../components/TeamCalendarAccordeon'
import TeamCalendarDateFilters from '../components/TeamCalendarDateFilters'
import TeamCalendarDates from '../components/TeamCalendarDates'
import TeamCalendarHeader from '../components/TeamCalendarHeader'
import TeamCalendarList from '../components/TeamCalendarList'
import useFetchTeam from '../hooks/useFetchTeam'
import TeamCalendarSkeleton from '../skeletons/TeamCalendarSkeleton'

const TeamCalendar = function () {
  const now = new Date()
  const currentYear = now.getFullYear()
  const [year, setYear] = useState(currentYear)
  const [month, setMonth] = useState(now.getMonth() + 1)
  const [user, setUser] = useState(null)
  const [team, setTeam] = useState(null)
  const [representation, setRepresentation] = useState('accordeon')
  const [showRequested, setShowRequested] = useState(false)

  const { response, loading, error } = useFetchTeam(year, month, showRequested)

  useEffect(() => {
    if (response) {
      setUser(response.user)
      setTeam(response.team)
    }
  }, [response])

  const handleSwitch = (e) => {
    setShowRequested(e.target.checked)
  }

  return (
    <>
      {error ? (
        <Alert severity="error">
          Se ha producido un error en la consulta de datos. Por favor, inténtelo de nuevo más tarde
        </Alert>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box>
            <Box
              sx={{
                flexGrow: 1,
                mt: 4,
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: 2,
              }}
            >
              <Typography
                variant="caption"
                gutterBottom
                sx={{
                  padding: '2px 10px',
                  boxShadow: '#ff7800 0px -4px 0px 0px inset',
                }}
              >
                No Laboral
              </Typography>

              <Typography
                variant="caption"
                gutterBottom
                sx={{ padding: '2px 10px', backgroundColor: '#ff7800' }}
              >
                Festivo
              </Typography>

              <Typography
                variant="caption"
                gutterBottom
                sx={{ padding: '2px 10px', backgroundColor: '#00a1ad' }}
              >
                Vacaciones disfrutadas
              </Typography>

              <Typography
                variant="caption"
                gutterBottom
                sx={{ padding: '2px 10px', boxShadow: '#00a1ad 0px -4px 0px 0px inset' }}
              >
                Vacaciones autorizadas
              </Typography>

              {showRequested && (
                <Typography
                  variant="caption"
                  gutterBottom
                  sx={{
                    padding: '2px 10px',
                    boxShadow: '#fad101 0px -4px 0px 0px inset',
                  }}
                >
                  Vacaciones solicitadas
                </Typography>
              )}
              <Typography
                variant="caption"
                gutterBottom
                sx={{ padding: '2px 10px', backgroundColor: '#cf0909', color: '#000' }}
              >
                Permisos disfrutados
              </Typography>

              <Typography
                variant="caption"
                gutterBottom
                sx={{
                  padding: '2px 10px',
                  boxShadow: '#cf0909 0px -4px 0px 0px inset',
                }}
              >
                Permisos autorizados
              </Typography>
              {showRequested && (
                <Typography
                  variant="caption"
                  gutterBottom
                  sx={{
                    padding: '2px 10px',
                    boxShadow: '#d900ff 0px -4px 0px 0px inset',
                  }}
                >
                  Permisos solicitados
                </Typography>
              )}
              <Typography
                variant="caption"
                gutterBottom
                sx={{
                  padding: '2px 10px',
                  boxShadow: '#acc433 0px -4px 0px 0px inset',
                }}
              >
                ITs
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 1 }}>
              <FormControlLabel
                control={<Switch defaultChecked onChange={handleSwitch} checked={showRequested} />}
                label="Mostrar solicitados"
              />
              <ToggleButtonGroup
                value={representation}
                size="small"
                exclusive
                onChange={(event, value) => {
                  setRepresentation(value)
                }}
              >
                <ToggleButton key="accordeon" value="accordeon" aria-label="accordeon">
                  <Box sx={{ display: 'flex', alignContent: 'center', gap: 1 }}>
                    <UnfoldMoreIcon />
                    <Typography
                      sx={{
                        display: {
                          xs: 'none', // móvil
                          sm: 'block', // tablet en adelante
                        },
                      }}
                    >
                      Vista Amplia
                    </Typography>
                  </Box>
                </ToggleButton>
                <ToggleButton key="list" value="list" aria-label="list">
                  <Box sx={{ display: 'flex', alignContent: 'center', gap: 1 }}>
                    <FormatListBulleted />
                    <Typography
                      sx={{
                        display: {
                          xs: 'none', // móvil
                          sm: 'block', // tablet en adelante
                        },
                      }}
                    >
                      Vista Compacta
                    </Typography>
                  </Box>
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
            <TeamCalendarDateFilters
              loading={loading}
              currentYear={currentYear}
              year={year}
              month={month}
              sx={{ mb: 4 }}
              onYearChange={(newYear) => setYear(newYear)}
              onMonthChange={(newMonth) => setMonth(newMonth)}
            />
          </Box>
          {loading ? (
            <TeamCalendarSkeleton />
          ) : (
            <>
              <TeamCalendarHeader key={'cal_head'} year={year} month={month} />
              <TeamCalendarDates key={`cal_user`} employee={user} />
              {representation == 'list' ? (
                <TeamCalendarList team={team} />
              ) : (
                <TeamCalendarAccordeon team={team} year={year} month={month} />
              )}
            </>
          )}
        </Box>
      )}
    </>
  )
}

export default TeamCalendar
